/*eslint eqeqeq: "off"*/
import * as HmiFiles from '../hmilib/hmifiles';

import * as hmidata from './hmidata';

import * as hmiclientbase from '../hmilib/hmiclientbase';

import * as ExperionScript from '../hmilib/hooks/ExperionScript';

import * as CentumVPScript from '../hmilib/hooks/CentumVPScript';
import * as PoleSctipt from '../hmilib/hooks/PoleScript';

import * as echarts from 'echarts/lib/echarts';

import $ from 'jquery';
import 'jqueryui';
import 'jqueryui/jquery-ui.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import FaceplateManager from '../FaceplateManager';
import { IPens, ITrendData } from '../modules/trends';
import {
    AddEvents,
    ExportHistoryRaw,
    ExportReadProcessed,
    GetEvents,
    GetListCol,
    ReadAtTime,
    ReadProcessed,
    ReadRaw,
    UpdateTags
} from './api';
import { GetParamGlobal, SetParamGlobal } from './hmiclientsdata';
import {
    IHistoryApi,
    ParamCVRequest,
    ParamRequest,
    TAddEventsAsync,
    TExportCSVAsync,
    TGetEventsAsync,
    TGetListColAsync,
    TReadAtTimeAsync,
    TReadProcessedAsync,
    TReadRawAsync,
    TUpdateTagsAsync
} from './interfaces';

export enum TypeSystemEnum {
    Pole = 1,
    ExperionPks = 2,
    WebElement = 3,
    CentumVP = 4
}

export const changeValueEvent = new CustomEvent('changeValue');

export const windowCycleEvent = new CustomEvent('windowCycle');

interface SourceChangeEvent {
    ns: number; // 0 - window, 1 - tag, 2 - id element
    s: string; // example: 'id1'
    e: string; // example: changeValue
}

export class SourceChange extends EventTarget {
    constructor(name: string) {
        super();
    }

    private _value: any;
    get value() {
        return this._value;
    }

    on(event: SourceChangeEvent) {
        let obj = this.FindEventObject(event);
        if (obj) obj.addEventListener(event.e, this.run);
    }

    private FindEventObject(event: SourceChangeEvent): any {
        let obj: any = null;

        if (event.ns == 0) {
            obj = document;
        } else if (event.ns == 1) {
            obj = null;
        } else if (event.ns == 2) {
            obj = document.getElementById(event.s);
        }

        return obj;
    }

    off(event: SourceChangeEvent) {
        let obj = this.FindEventObject(event);
        if (obj) obj.removeEventListener(event, this.run);
    }

    private run() {
        this.value = Math.floor(Math.random() * 2);
        console.log('Run: ' + this._value);
    }

    set value(value) {
        this._value = value;
        this.dispatchEvent(changeValueEvent);
    }
}
export interface ISystemGlobal {
    ContextMenuDiv: (event: any, item: string, trendparam: string, typemenu: number, x: number, y: number) => any;
}

export interface ISystemLib {
    funglobal?: ISystemGlobal;
}

export interface ITrendBase {
    TrendsBase: { [id: string]: ITrendData | undefined };
    IntTrend(id: string): ITrendData | undefined;
    RemoveTrend(id: string): any;
}

declare global {
    interface Window {
        OpenMnemo: any;
        AddContextTag: any;
        ReOpenMnemo: any;
        ReLoadMnemo: any;
        OpenMnemoGlobal: any;
        OpenWinMain: any;
        OpenNewWindow: any;
        OpenWinSpecial: any;
        OpenFaceplate: any;
        OpenFaceplateTun: any;
        BeforeMnemo: any;
        CloseSpecial: any;
        EventFrameClick: any;
        SearchRun: any;
        BeforeMnemoList: string[];
        GetParam: any;
        GetParamValue: any;
        SetParam: any;
        SetParams: (params: Array<ParamRequest>) => void;
        SetParamCV: (path: string, value: string, quality: number, time: string) => Promise<boolean>;
        SetParamsCV: (params: Array<ParamCVRequest>) => Promise<boolean>;
        GetConnectState: any;
        LoadHashFun: any;
        GetArchiveConfig: any;
        GetItemList: any;
        GetParamsItem: any;
        SubItems: any;
        UnSubItems: any;
        ContextMenu: any;
        CloseContextMenu: any;
        DonwloadJson: any;
        ConverImageBase64: any;
        GetIdAndHost: any;
        TypeSystem: TypeSystemEnum;
        MaxSpecialWindow: number;
        LeftMain: number;
        TopMain: number;
        EventMouseClick: MouseEvent;
        getSystemLib: () => ISystemLib; ///Используется для подключения библиотек разных систем
        setSystemLib: (obj: ISystemLib) => any;
        Base: any;
        EditorRuntime: any;
        GWin: any;
        HDAServer: IHistoryApi;
        GetMnemoState: any;
        GetActiveMnemo: any;
        DownloadApPDF: any;
        TestGet: any;
        Server: any;
        Statistic: any;
        ConvertDateNsToISO: any;
        ConvertDateISOtoNs: any;
        EventSelectedMenuItem: any;
        DeltaTimeCurAndSys: number;
        SystemDate: any;
        CookieFun: any;
        InputElementValue: any;
        Mouse: any;
        OpenMnemoSpecial: any;
        Faceplates: string[];
        hostdata: string;
        ExperionCommand: Function;
        CentumVP: any;
        Pole: any;
        Trends: ITrendBase;
        charts: any;
        arr: any;
        CloseMnemo: any;
        NumberFormat: any;
        AnimationData: any;
        Events: any;
        ReactRoot: any;
        Search3D: string;
    }
    interface Date {
        toDateInputValue: () => string;
    }
}

window.charts = echarts;

window.CentumVP = CentumVPScript.CentumVP;
window.Pole = PoleSctipt.Pole;

Date.prototype.toDateInputValue = function () {
    var date = new Date(this);
    let str = '';
    let year, month, day, hour, min, sec;
    year = date.getFullYear();
    month = date.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    day = date.getDate();
    day = day < 10 ? '0' + day : day;
    hour = date.getHours();
    hour = hour < 10 ? '0' + hour : hour;
    min = date.getMinutes();
    min = min < 10 ? '0' + min : min;

    sec = date.getSeconds();
    sec = sec < 10 ? '0' + sec : sec;

    str += year + '-' + month + '-' + day;
    str += 'T' + hour + ':' + min + ':' + sec;

    return str;
};

function SetHostName() {
    window.hostdata = '/ixyber/base';

    if (process.env.NODE_ENV == 'development') {
        //window.hostdata = "http://localhost:5050/ixyber/base";//"http://monitorapc_server:5104";
        //window.hostdata = "http://172.30.203.160:5050/ixyber/base";//"http://monitorapc_server:5104";
        // window.hostdata = 'https://ixyberproxydemo/ixyber/base'; //"http://monitorapc_server:5104";
        // window.hostdata = "http://ixybertomskserver:5050/ixyber/base";

        // window.hostdata = 'http://172.30.203.135:5050/ixyber/base'; //ixyberalt
        // window.hostdata = "http://172.30.203.166:5050/ixyber/base"; //u362server

        // window.hostdata = "https://u362_server/ixyber/base"; //u362server
        //window.hostdata = "https://u2110server/ixyber/base"; //u2110server
        // window.hostdata = "https://ots/ixyber/base"; //ots
        // window.hostdata = 'https://172.30.203.216/ixyber/base'; //agroxyber
        window.hostdata = 'https://bn-ktk-2110/ixyber/base'; //ots
        // window.hostdata = "http://172.30.203.79:5050/ixyber/base"; //ixyberots-test
    } else {
        let getCookie = function (name: string) {
            let matches = document.cookie.match(
                new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
            );
            return matches ? decodeURIComponent(matches[1]) : undefined;
        };

        let cookehostdata = getCookie('hostdata');
        if (cookehostdata != null && cookehostdata != '') {
            let hostok = [
                'http://172.30.203.191:5050/ixyber/base',
                'http://172.30.203.191/ixyber/base',
                '/ixyber/base'
            ];

            if (hostok.indexOf(cookehostdata) != -1) {
                window.hostdata = cookehostdata;
                alert('Attention! An invalid server change has occurred! Use for tests only');
            }
        }
    }
}

SetHostName();

window.Mouse = undefined;

document.addEventListener('click', windowClick);

function windowClick(e: any) {
    window.InputElementValue.ClearUpdateDataScrol();
}

document.addEventListener('mousemove', onMouseUpdate);

function onMouseUpdate(e: any) {
    window.Mouse = e;
}

window.Trends = {
    TrendsBase: {},
    IntTrend: function (id: string): ITrendData | undefined {
        let defTrend: ITrendData | undefined = {
            id: id,
            brush: {
                areas: []
            },
            dispatchAction: function (payload: any) {},
            on: function (eventName: string, handler: Function) {},
            off: function (eventName: string, handler: Function) {},
            setParam: function (param: any) {},
            addPen: function (pen: IPens, data: any): number {
                return -1;
            },
            delPen: function (idPen: number): number {
                return -1;
            },
            clearTrend: function () {}
        };

        if (this.TrendsBase[id] == null) {
            this.TrendsBase[id] = defTrend;
        }

        return this.TrendsBase[id];
    },
    RemoveTrend: function (id: string) {
        delete this.TrendsBase[id];
    }
};

window.addEventListener('wheel', function (event: any) {
    window.InputElementValue.EventUpdateDataScrol(event);
});

window.InputElementValue = {
    UpdateDataScrolObject: {
        tag: '',
        delta: 100,
        min: 0,
        max: 0
    },
    newtext: undefined,
    UpdateDataScrolActiv: false,
    Create: function (tag: string, delta: number, min: number, max: number) {
        let event = window.Mouse as MouseEvent;

        if (event != undefined) {
            this.UpdateDataScrolActiv = true;
            if (this.newtext != null) {
                window.UnSubItems([this.UpdateDataScrolObject.tag]);
            } else {
                this.newtext = document.createElement('input');
                this.newtext.setAttribute('disabled', 'disabled');
                this.newtext.id = 'inputscrollvalue';
                (this.newtext as HTMLInputElement).type = 'text';
                this.newtext.style.position = 'absolute';
                this.newtext.style.width = '40px';
                this.newtext.style.zIndex = '100';
                document.body.appendChild(this.newtext);
            }

            this.UpdateDataScrolObject.tag = tag || '';
            this.UpdateDataScrolObject.delta = delta || 100;
            this.UpdateDataScrolObject.min = min || 0;
            this.UpdateDataScrolObject.max = max || 100;

            this.newtext.style.visibility = 'hidden';

            this.newtext.onchange = function () {
                window.SetParam(tag, Number((this as HTMLInputElement)?.value));
            };

            if (document.activeElement != null) {
                this.newtext.style.left = event.clientX + 10 + 'px';
                this.newtext.style.top = event.clientY + 15 + 'px';
            }

            window.SubItems([tag]);
            (this.newtext as HTMLInputElement).value = window.GetParam(tag).Value;
        }
    },
    EventUpdateDataScrolState: undefined,
    funcUpdateDataScrol: function () {
        //console.log("hidenn");
        if (this.newtext != null) {
            this.newtext.style.visibility = 'hidden';
        }
    },
    EventUpdateDataScrol: function (e: any) {
        if (this.newtext != null) {
            e = e || window.event;
            var a = Number((this.newtext as HTMLInputElement).value); //GetParam(this.UpdateDataScrolObject.tag).Value;

            if (a != null) {
                this.newtext.style.visibility = 'visible';
                var delta = e.deltaY || e.detail || e.wheelDelta;
                a = +a - delta / this.UpdateDataScrolObject.delta;
                a = a < this.UpdateDataScrolObject.max ? a : this.UpdateDataScrolObject.max;
                a = a >= this.UpdateDataScrolObject.min ? a : this.UpdateDataScrolObject.min;
                (this.newtext as HTMLInputElement).value = a.toFixed(1);
                let eventchange = new Event('change', { bubbles: true });
                this.newtext.dispatchEvent(eventchange);

                if (this.EventUpdateDataScrolState !== undefined) clearTimeout(this.EventUpdateDataScrolState);
                this.EventUpdateDataScrolState = setTimeout(() => this.funcUpdateDataScrol(), 1000);
            }
        }
    },
    ClearUpdateDataScrol: function () {
        if (!this.UpdateDataScrolActiv) {
            if (this.newtext != null) {
                this.newtext.parentElement.removeChild(this.newtext);
                this.newtext = undefined;
                window.UnSubItems([this.UpdateDataScrolObject.tag]);
            }
        } else {
            this.UpdateDataScrolActiv = false;
        }
    }
};

window.CookieFun = {
    getCookie: function (name: string) {
        let matches = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookie: function (name: string, value: any, options: any = {}) {
        options = {
            path: '/',
            // при необходимости добавьте другие значения по умолчанию
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += '; ' + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += '=' + optionValue;
            }
        }

        document.cookie = updatedCookie;
    },
    deleteCookie: function (name: string) {
        this.setCookie(name, '', {
            'max-age': -1
        });
    }
};

window.EventSelectedMenuItem = 'LUKOIL';
window.addEventListener('EventSelectedMenuItem', (ev: any) => {
    //console.debug("IdItem=" + ev.detail.id);
    window.EventSelectedMenuItem = ev.detail.id;
});

window.ConvertDateNsToISO = (datelong: number) => {
    return new Date(datelong / 1000000);
};

window.ConvertDateISOtoNs = (datelong: Date) => {
    return datelong.getTime() * 1000000;
};

window.SystemDate = () => {
    return new Date(Date.now() - window.DeltaTimeCurAndSys);
};

window.ReLoadMnemo = function (obj: any) {
    let mnemodiv = obj.closest('[data-mnemoinfo]');
    let mnemoinfo = mnemodiv.getAttribute('data-mnemoinfo');
    let mnemoinfoobj = JSON.parse(mnemoinfo);
    let beginparam = '';
    if (mnemoinfoobj.bindings != null) {
        for (let key in mnemoinfoobj.bindings) {
            if (beginparam != '') beginparam += '&';
            beginparam += key + '=' + mnemoinfoobj.bindings[key];
        }
    }
    let comandopen = mnemoinfoobj.file + '?' + beginparam;

    window.OpenMnemo(comandopen);
};

window.ReOpenMnemo = function (name: any) {
    for (let item in HmiFiles.MnemoList) {
        if (HmiFiles.MnemoList[item].obj == window.event?.currentTarget) {
            window.OpenMnemo(name, null, HmiFiles.MnemoList[item].framewindow.frameElement);
        }
    }
};

window.Server = {
    Scripts: {
        PyAsync: function (scriptname: string, args: object) {
            return hmiclientbase.ScriptServerRunPyAsync(scriptname, args);
        },
        SaveJsonFile: function (jsonObj: string, fileName: string) {
            return hmiclientbase.ScriptServerSaveJsonFile(jsonObj, fileName);
        },
        ReadJsonFile: function (fileName: string) {
            return hmiclientbase.ScriptServerReadJsonFile(fileName);
        }
    }
};

window.Statistic = {
    R2: async function (
        y_id: string,
        x_id: string,
        begin: string,
        end: string,
        limit: number = 0,
        getBounds: number = 0
    ) {
        let scriptname = 'R2';
        let args = {
            y_id,
            x_id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    },
    CKO: async function (id: string, begin: string, end: string, limit: number = 0, getBounds: number = 0) {
        let scriptname = 'CKO';
        let args = {
            id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    },
    MIN: async function (id: string, begin: string, end: string, limit: number = 0, getBounds: number = 0) {
        let scriptname = 'MIN';
        let args = {
            id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    },
    MAX: async function (id: string, begin: string, end: string, limit: number = 0, getBounds: number = 0) {
        let scriptname = 'MAX';
        let args = {
            id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    },
    MEAN: async function (id: string, begin: string, end: string, limit: number = 0, getBounds: number = 0) {
        let scriptname = 'MEAN';
        let args = {
            id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    },
    AVERAGE: async function (id: string, begin: string, end: string, limit: number = 0, getBounds: number = 0) {
        let scriptname = 'AVERAGE';
        let args = {
            id,
            begin,
            end,
            limit,
            getBounds
        };
        return await window.Server.Scripts.PyAsync(scriptname, args);
    }
};

window.TestGet = async function () {
    return Promise.resolve(1);
};

/*
window.TestGet = function () {
    let hostdata = "http://udp-portal-dev.lukoil.com";
    fetch(hostdata + `"/Points/search?query=*`).then(response => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
    }).then((data: any) => {
        console.log(data);
    }).catch(error => {
            console.log("error", error);
            return {};
    });
}
*/
window.GetActiveMnemo = function () {};

window.DownloadApPDF = function (fileName: string = '') {
    let url = window.location.toString();
    let frameName = '';

    if (document.activeElement?.hasAttribute('name')) {
        frameName = document.activeElement?.getAttribute('name') || '';
    }

    hmiclientbase.DownloadPDF(url, frameName, fileName);
};

window.GetMnemoState = function () {
    let res: any[] = [];
    for (let i = 0; i < HmiFiles.MnemoList.length; i++) {
        let state = HmiFiles.MnemoList[i].state;
        res.push(state);
    }
    return res;
};

window.GWin = window;

let shapes: any = {};

window.EditorRuntime = {
    tempIDs: {},
    AddShape: function (name: string, parent: any) {
        this.tempIDs = {};
        let gennum: number = 0;
        let binding: any = null;

        let disassembleName = DisassembleName(name);
        name = disassembleName.name.toLowerCase();
        gennum = disassembleName.gennum;
        binding = disassembleName.binding;

        let shapeobj: any = undefined;
        if (shapes[name]) {
            let newShapeBind = shapes[name].firstElementChild.cloneNode(true);

            HmiFiles.ReplaceConstants(newShapeBind);

            HmiFiles.Bindings(binding, newShapeBind);
            HmiFiles.SetBindings(gennum, newShapeBind);

            let ownerDocument = parent.ownerDocument;
            let doc = undefined;

            let listmnemo = HmiFiles.MnemoList;
            for (let i = 0; listmnemo.length; i++) {
                if (listmnemo[i].framewindow.document == ownerDocument) {
                    doc = listmnemo[i].obj;
                    break;
                }
            }
            if (parent.nodeName === 'DIV') {
                let newSvg = new DOMParser().parseFromString(
                    '<svg xmlns="http://www.w3.org/2000/svg" transform="matrix(1,0,0,1,0,0)" ></svg>',
                    'text/xml'
                ).firstElementChild;
                parent.appendChild(newSvg);
                parent = newSvg;
            }

            if (doc != undefined) {
                HmiFiles.SubItemsElem(newShapeBind, doc);

                let [newShape, def, forObj] = window.EditorRuntime.shape_for_paste(newShapeBind, parent);

                if (def != null) {
                    let defs = doc.getElementsByTagName('defs')[0];
                    if (defs == null) {
                        defs = document.createElement('defs');
                        doc.appendChild(defs);
                    }

                    for (let i = 0; i < def.children.length; i++) {
                        let child = def.children[i];
                        if (child != null) {
                            defs.appendChild(child);
                        }
                    }
                }

                if (forObj != undefined) {
                    const dataListsSVGContent = doc.getElementsByTagName('datalinklists')[0];
                    if (dataListsSVGContent != undefined) {
                        const dataList = forObj.getElementsByTagName('datalinklists')[0];
                        for (let i = 0; 0 < dataList.children.length; i++) {
                            const child = dataList.children[0];
                            if (child.children.length != 0) {
                                dataListsSVGContent.appendChild(child);
                            } else {
                                child.remove();
                            }
                        }
                    }
                }

                parent.appendChild(newShape);

                HmiFiles.goodload(parent, null, newShape, doc);

                shapeobj = newShape;
            }
        }

        return shapeobj;
    },
    DeleteShape: (obj: SVGElement) => {
        if (obj && obj.parentElement && obj.tagName.toLowerCase() == 'svg') {
            const elements = obj.querySelectorAll('[data-datalinklistid]');
            const parent = obj.parentElement;
            let doc = undefined;
            let ownerDocument = parent.ownerDocument;
            let listmnemo = HmiFiles.MnemoList;
            for (let i = 0; listmnemo.length; i++) {
                if (listmnemo[i].framewindow.document == ownerDocument) {
                    doc = listmnemo[i].obj;
                    break;
                }
            }

            let dataListsSVGContent = doc.getElementsByTagName('datalinklists')[0];

            elements.forEach((element) => {
                const datalinklistId = element.getAttribute('data-datalinklistid');
                if (datalinklistId) {
                    const elementToRemove = dataListsSVGContent.querySelector(`#${CSS.escape(datalinklistId)}`);

                    if (elementToRemove) {
                        elementToRemove.remove();
                    }
                }
            });

            parent.removeChild(obj);
        }
    },
    delete_svg_obj: function (obj: any) {
        if (obj != null) {
            let temp = obj.parentElement.removeChild(obj);
            temp.innerHTML = '';
        }
    },
    SetNewID: function (svgobj: any, parent: any) {
        let doc = parent.ownerDocument;
        let name = svgobj.localName;
        let Id: string = '';
        let newId: string = '';

        while (true) {
            Id = `f${(+new Date()).toString()}`;
            newId = name + Id;
            if (doc.getElementById(newId) == null && this.tempIDs[newId] == null) {
                this.tempIDs[newId] = 1;
                break;
            }
        }

        svgobj.setAttribute('id', newId);
    },
    //подготовка шейпа для вставки
    shape_for_paste: function (shape: any, parent: any) {
        if (shape != undefined) {
            let obj = shape;
            let defs: any = undefined;
            if (obj.getElementsByTagName('defs')[0] != null) {
                defs = obj.getElementsByTagName('defs')[0].cloneNode(true);
                this.delete_svg_obj(obj.getElementsByTagName('defs')[0]);
            }

            let forObj = obj.querySelector('#animationselement');
            if (forObj != null) {
                forObj = forObj.cloneNode(true);
                this.delete_svg_obj(obj.querySelector('#animationselement'));
            } else {
                forObj = undefined;
            }

            {
                let element = obj;
                if (
                    element.nodeName != 'bindingsetlist' &&
                    element.nodeName != 'datalinklist' &&
                    element.id != 'animationselement'
                ) {
                    let old_id = element.id;
                    window.EditorRuntime.SetNewID(element, parent);
                    let new_id = element.id;
                    let fill = element.style.fill;

                    element.setAttribute('original_id', old_id);

                    if (fill.indexOf('url("#') >= 0) {
                        fill = fill.substring(6, fill.length - 2);

                        let grad_obj = defs.querySelectorAll('#' + fill)[0];
                        if (grad_obj != undefined && grad_obj.nodeName != undefined) {
                            if (grad_obj.nodeName == 'linearGradient') {
                                if (fill.indexOf('level') > 0) {
                                    let name_fillgrad = fill.substring(0, fill.indexOf('level'));
                                    element.style.fill = element.style.fill.replace(name_fillgrad, new_id);
                                    grad_obj.id = grad_obj.id.replace(name_fillgrad, new_id);
                                } else {
                                    element.style.fill = 'url("#' + new_id + 'lingradfill")';
                                    grad_obj.id = new_id + 'lingradfill';
                                }
                            } else if (grad_obj.nodeName == 'radialGradient') {
                                let name_fillgrad = fill;
                                element.style.fill = 'url("#' + new_id + 'radgradfill")';
                                grad_obj.id = new_id + 'radgradfill';
                            }
                        } else {
                            //console.log('Шейп ' + element.id + ' отсутствует fill');
                        }
                    } else {
                        fill = undefined;
                    }

                    let stroke = element.style.stroke;

                    if (stroke.indexOf('url("#') >= 0) {
                        stroke = stroke.substring(6, stroke.length - 2);

                        let grad_obj = defs.querySelectorAll('#' + stroke)[0];
                        if (grad_obj != undefined && grad_obj.nodeName != undefined) {
                            if (grad_obj.nodeName != undefined) {
                                if (grad_obj.nodeName == 'linearGradient') {
                                    element.style.stroke = 'url("#' + new_id + 'lingradstroke")';
                                    grad_obj.id = new_id + 'lingradstroke';
                                } else if (grad_obj.nodeName == 'radialGradient') {
                                    element.style.stroke = 'url("#' + new_id + 'radgradstroke")';
                                    grad_obj.id = new_id + 'radgradstroke';
                                }
                            }
                        } else {
                            //console.log('Шейп ' + element.id + ' отсутствует stroke');
                        }
                    } else {
                        stroke = undefined;
                    }

                    if (forObj != undefined) {
                        let bindListID = element.getAttribute('data-bindingsetlistid');
                        if (bindListID != undefined) {
                            let bindList = forObj.querySelector('#' + bindListID);
                            if (bindList != null) {
                                window.EditorRuntime.SetNewID(bindList, parent);
                                let newBindListID = bindList.id;
                                element.setAttribute('data-bindingsetlistid', newBindListID);
                            } else {
                                //console.log('Шейп ' + element.id + ' отсутствует bindinglist');
                            }
                        }

                        let dataListID = element.getAttribute('data-datalinklistid');
                        if (dataListID != undefined) {
                            let dataList = forObj.querySelector('#' + dataListID);
                            if (dataList != null) {
                                window.EditorRuntime.SetNewID(dataList, parent);
                                let newDataListID = dataList.id;
                                element.setAttribute('data-datalinklistid', newDataListID);
                            } else {
                                // console.log('Шейп ' + element.id + ' отсутствует datalist');
                            }
                        }
                    }
                }
            }

            let shp_rename_g = function (gr: any, defs: any, forObj: any) {
                for (let i = 0; i < gr.children.length; i++) {
                    let element = gr.children[i];
                    if (
                        element.nodeName != 'bindingsetlist' &&
                        element.nodeName != 'datalinklist' &&
                        element.id != 'animationselement'
                    ) {
                        let old_id = element.id;
                        window.EditorRuntime.SetNewID(element, parent);
                        let new_id = element.id;
                        let fill = element.style.fill;

                        element.setAttribute('original_id', old_id);

                        if (fill.indexOf('url("#') >= 0) {
                            fill = fill.substring(6, fill.length - 2);

                            let grad_obj = defs.querySelectorAll('#' + fill)[0];
                            if (grad_obj != undefined && grad_obj.nodeName != undefined) {
                                if (grad_obj.nodeName == 'linearGradient') {
                                    if (fill.indexOf('level') > 0) {
                                        let name_fillgrad = fill.substring(0, fill.indexOf('level'));
                                        element.style.fill = element.style.fill.replace(name_fillgrad, new_id);
                                        grad_obj.id = grad_obj.id.replace(name_fillgrad, new_id);
                                    } else {
                                        element.style.fill = 'url("#' + new_id + 'lingradfill")';
                                        grad_obj.id = new_id + 'lingradfill';
                                    }
                                } else if (grad_obj.nodeName == 'radialGradient') {
                                    let name_fillgrad = fill;
                                    element.style.fill = 'url("#' + new_id + 'radgradfill")';
                                    grad_obj.id = new_id + 'radgradfill';
                                }
                            } else {
                                //console.log('Шейп ' + element.id + ' отсутствует fill');
                            }
                        } else {
                            fill = undefined;
                        }

                        let stroke = element.style.stroke;

                        if (stroke.indexOf('url("#') >= 0) {
                            stroke = stroke.substring(6, stroke.length - 2);

                            let grad_obj = defs.querySelectorAll('#' + stroke)[0];
                            if (grad_obj != undefined && grad_obj.nodeName != undefined) {
                                if (grad_obj.nodeName != undefined) {
                                    if (grad_obj.nodeName == 'linearGradient') {
                                        element.style.stroke = 'url("#' + new_id + 'lingradstroke")';
                                        grad_obj.id = new_id + 'lingradstroke';
                                    } else if (grad_obj.nodeName == 'radialGradient') {
                                        element.style.stroke = 'url("#' + new_id + 'radgradstroke")';
                                        grad_obj.id = new_id + 'radgradstroke';
                                    }
                                }
                            } else {
                                //console.log('Шейп ' + element.id + ' отсутствует stroke');
                            }
                        } else {
                            stroke = undefined;
                        }

                        if (forObj != undefined) {
                            let bindListID = element.getAttribute('data-bindingsetlistid');
                            if (bindListID != undefined) {
                                let bindList = forObj.querySelector('#' + bindListID);
                                if (bindList != null) {
                                    window.EditorRuntime.SetNewID(bindList, parent);
                                    let newBindListID = bindList.id;
                                    element.setAttribute('data-bindingsetlistid', newBindListID);
                                } else {
                                    // console.log('Шейп ' + element.id + ' отсутствует bindinglist');
                                }
                            }

                            let dataListID = element.getAttribute('data-datalinklistid');
                            if (dataListID != undefined) {
                                let dataList = forObj.querySelector('#' + dataListID);
                                if (dataList != null) {
                                    window.EditorRuntime.SetNewID(dataList, parent);
                                    let newDataListID = dataList.id;
                                    element.setAttribute('data-datalinklistid', newDataListID);
                                } else {
                                    // console.log('Шейп ' + element.id + ' отсутствует datalist');
                                }
                            }
                        }

                        if (element.nodeName == 'g' || element.nodeName == 'foreignObject') {
                            shp_rename_g(element, defs, forObj);
                        }
                    }
                }
            };

            shp_rename_g(obj, defs, forObj);

            return [obj, defs, forObj];
        }
    },

    UpdateShape: function () {
        let xhr = new XMLHttpRequest();
        let query = '/ixyber/vision/EditorVision/getshapes';

        xhr.open('GET', query, false);
        xhr.send();

        let result: any = [];

        if (xhr.status != 200) {
            alert(xhr.status + ': ' + xhr.statusText);
            return;
        } else {
            result = JSON.parse(xhr.response);
        }

        for (let key in result) {
            let obj = result[key];

            for (let i = 0; i < obj.length; i++) {
                let temp = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

                let xmltemp = StringToXMLDom(obj[i]);
                if (xmltemp) {
                    temp = xmltemp.querySelectorAll('svg')[0];
                    obj[i] = temp;
                }
            }
        }

        let newResult: any = {};

        for (let key in result) {
            //let newMass:any = newResult[key.toLowerCase()] = [];
            let oldMass: any = result[key];
            for (let i = 0; i < oldMass.length; i++) {
                let clone = oldMass[i].cloneNode(true);
                clone.id = clone.id.toLowerCase();
                let shapename = 'shapes\\' + key.toLowerCase() + '\\' + clone.id;
                clone.firstElementChild.setAttribute('shapename', shapename);
                newResult[shapename] = clone;
            }
        }

        shapes = newResult;
    }
};

window.EditorRuntime.UpdateShape();

const ReadRawAsync: TReadRawAsync = async (Items, starttimeiso, endtimeiso, limit = 0, getBounds = 0) => {
    starttimeiso = new Date(starttimeiso).toISOString();
    endtimeiso = new Date(endtimeiso).toISOString();
    return ReadRaw(Items, starttimeiso, endtimeiso, limit, getBounds);
};
const ReadProcessedAsync: TReadProcessedAsync = async (
    ids,
    aggregateType,
    starttimeiso,
    endtimeiso,
    processingIntervalNS
) => {
    starttimeiso = new Date(starttimeiso).toISOString();
    endtimeiso = new Date(endtimeiso).toISOString();

    return ReadProcessed(ids, aggregateType, starttimeiso, endtimeiso, processingIntervalNS);
};
const ReadAtTimeAsync: TReadAtTimeAsync = async (Items, TimeArray) => {
    for (let i = 0; i < TimeArray.length; i++) {
        TimeArray[i] = new Date(TimeArray[i]).toISOString();
    }

    return ReadAtTime(Items, TimeArray);
};
const GetEventsAsync: TGetEventsAsync = async (sortCol, sortUp, sortItems, selectPage, limit) => {
    return GetEvents(sortCol, sortUp, sortItems, selectPage, limit);
};

export const downloadFile = (blobfile: Blob) => {
    const link = document.createElement('a'),
        filename = 'export.csv';
    link.href = URL.createObjectURL(blobfile);
    link.download = filename;
    link.click();
    return {};
};

const ExportCSVAsync: TExportCSVAsync = async (
    ids,
    minTime,
    maxTime,
    downloadDelimiter,
    downloadType,
    downloadTime
) => {
    const starttimeiso = new Date(minTime).toISOString();
    const endtimeiso = new Date(maxTime).toISOString();

    if (downloadType == 1) {
        const time = downloadTime.split(':');
        const resample = Number(time[0]) * 3600000 + Number(time[1]) * 60000 + Number(time[2]) * 1000 * 1000000;
        const nameFun = [];

        for (let value of ids) {
            nameFun.push('INTERPOLATIVE');
        }

        ExportReadProcessed(ids, nameFun, starttimeiso, endtimeiso, resample, downloadDelimiter).then((blob) =>
            downloadFile(blob)
        );
    } else if (downloadType == 2) {
        ExportHistoryRaw(ids, starttimeiso, endtimeiso, 0, 0, downloadDelimiter).then((blob) => downloadFile(blob));
    }
};

const UpdateTagsAsync: TUpdateTagsAsync = async (tags) => {
    return UpdateTags(tags);
};

const GetListColAsync: TGetListColAsync = async (name) => {
    return GetListCol(name);
};

const AddEventsAsync: TAddEventsAsync = async (items) => {
    return AddEvents(items);
};

window.HDAServer = <IHistoryApi>{
    //Tags
    ReadRawAsync: ReadRawAsync,
    ReadProcessedAsync: ReadProcessedAsync,
    ReadAtTimeAsync: ReadAtTimeAsync,
    ExportCSV: ExportCSVAsync,
    UpdateTags: UpdateTagsAsync,
    //Events
    AddEventsAsync: AddEventsAsync,
    GetListColAsync: GetListColAsync,
    GetEvents: GetEventsAsync
};

window.Base = {
    GetObject: function (name: string) {
        let rez = hmiclientbase.GetObject(name);
        return rez;
    },
    fetchGetObject: async (name: string) => {
        let rez = await hmiclientbase.UpdateObject(name);
        return rez;
    },
    CreateObject: async (name: string, TypeName: string, idParent: string, typeStyle: string) => {
        const obj = await hmiclientbase.SettingsCreateObject(name, TypeName, idParent, typeStyle);
        return obj;
    },
    CreateObjectTemplate: async (name: string, TypeName: string, idParent: string, bindingValue: string) => {
        const obj = await hmiclientbase.CreateObjectTemplate(name, TypeName, idParent, bindingValue);
        return obj;
    },
    DeleteObject: async (id: string, deleteAll: boolean) => {
        return await hmiclientbase.SettingsDeleteObject(id, deleteAll);
    },
    PasteObject: async (id: string, idParent: string) => {
        return await hmiclientbase.PasteObject(id, idParent);
    },
    Events: {
        GetActiveEvents: function (): hmiclientbase.IEventsBase {
            return hmiclientbase.GetActiveEvents();
        },
        AckEvents: function (ids: string[]) {
            hmiclientbase.AckEvents(ids);
        },
        AckEventsBlock: function (path: string) {
            hmiclientbase.AckEventsBlock(path);
        },
        RemoveEvents: function (ids: string[]) {
            hmiclientbase.RemoveEvents(ids);
        },
        MnemoAlarms: function (mnemoname: string) {
            return HmiFiles.GetMnemoAlarms(mnemoname);
        }
    }
};

//Конвертация из string в DOM объект
function StringToXMLDom(string: string) {
    let xmlDoc = null;
    if (window.DOMParser) {
        let parser = new DOMParser();
        xmlDoc = parser.parseFromString(string, 'image/svg+xml');
    }
    return xmlDoc;
}

let defSystemLib: ISystemLib = {
    funglobal: {
        ContextMenuDiv(event: any, item: string, trendparam: string, typemenu: number, x: number, y: number) {
            console.log('ok ContextMenuDiv');
        }
    }
};

let SystemLib: ISystemLib = defSystemLib;

window.getSystemLib = function (): ISystemLib {
    return SystemLib;
};

window.setSystemLib = function (newsystemlib: ISystemLib) {
    SystemLib = Object.assign(defSystemLib, newsystemlib);
};

let idpro = '-1';

let hostdata: string = '/ixyber/visiondata'; //"http://localhost:5104";

if (process.env.NODE_ENV == 'development') {
    hostdata = 'http://localhost:5104/ixyber/visiondata'; //"http://localhost:5104";
}

window.GetIdAndHost = function () {
    if (idpro == '-1') {
        idpro = '1';
        let params = window.location.search
            .replace('?', '')
            .split('&')
            .reduce(function (p: any, e: any) {
                let a = e.split('=');
                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                return p;
            }, {});

        if (params['id']) idpro = params['id'];
        if (params['dataid']) hostdata = '/ixyber/visiondata/' + params['dataid'];
    }

    return { id: idpro, host: hostdata };
};

window.DonwloadJson = function (txt: string) {
    HmiFiles.DonwloadJson(txt);
};

window.GetParamsItem = function (item: string): string[] {
    let rez = hmiclientbase.GetParamsItem(item);
    return rez.sort();
};

/*
window.GetParamsItem = function (item: string) {
    let rez:string[] = [];
    for (let name in hmiclientbase.Params) {
        if (name.indexOf(item + ".") == 0) {
            rez.push(name);
        }
    }
    return rez.sort();
}
*/

window.ConverImageBase64 = function ConverImageBase64(src: string, name: string) {
    let img = new Image();
    let nameImage;
    img.src = src;

    img.crossOrigin = 'Anonymous';

    img.onload = function () {
        draw(this);
    };

    function draw(img: any) {
        let canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext('2d');
        if (ctx != null) {
            ctx.drawImage(img, 0, 0);
            img.style.display = 'none';
            let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            let data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
                if (data[i] === data[0] || data[i + 1] === data[1] || data[i + 2] === data[2]) {
                    data[i + 3] = 0;
                }
            }

            ctx.putImageData(imageData, 0, 0);

            let fullQuality = canvas.toDataURL('image/png', 1);
            let t = document.getElementById(name);
            if (t) t.setAttribute('src', fullQuality);
        }
    }
};

window.SubItems = async function (params: string[]) {
    return await hmiclientbase.SubItems(params);
};

window.UnSubItems = function (params: string[]) {
    return hmiclientbase.UnSubItems(params);
};

window.GetItemList = async function (query: string = '', attributeQueries: any = null): Promise<string[]> {
    return await hmiclientbase.GetItemList();
};

window.GetArchiveConfig = function (): any {
    return hmiclientbase.HisttoryConfig;
};

window.GetConnectState = function (): boolean {
    return hmiclientbase.LoadState;
};

window.GetParamValue = function (name: string) {
    return window.GetParam(name).V;
};

window.SetParam = function (name: string, value: any, ack?: number) {
    if (window.TypeSystem == TypeSystemEnum.CentumVP) {
        CentumVPScript.CentumVP.SetParam(name, value, ack);
    } else {
        let isSetParam = true;
        if (ack == 1) {
            ///acknowledgement
            let index: number = name.lastIndexOf('.');
            if (index != -1 && index != name.length) {
                let param = name.substring(index + 1);
                let block = '';
                let tag = name.substring(0, index);
                isSetParam = false;
                isSetParam = confirm(name + ' = ' + value.toString());
            }
        } else if (ack == 2) {
            ///confirmation
            let index: number = name.lastIndexOf('.');
            if (index != -1 && index != name.length) {
                let param = name.substring(index + 1);
                let block = '';
                let tag = name.substring(0, index);
                isSetParam = false;
                isSetParam = confirm(name + ' = ' + value.toString());
            }
        }

        if (isSetParam) {
            if (!SetParamGlobal(name, value)) {
                return hmiclientbase.SetParam(name, value);
            }
        }
    }

    return 0;
};

window.SetParams = (params: Array<ParamRequest>) => {
    return hmiclientbase.SetParamBase(params);
};

function prepareParamCVData(params: Array<ParamCVRequest>) {
    return params.map((param) => ({
        path: param.path,
        value: JSON.stringify(param.value),
        quality: param.quality,
        time: param.time
    }));
}

window.SetParamCV = (path: string, value: string, quality: number, time: string): Promise<boolean> => {
    const data: Array<ParamCVRequest> = prepareParamCVData([{ path, value, quality, time }]);

    return hmiclientbase.SetParamCV(data);
};

window.SetParamsCV = (params: Array<ParamCVRequest>): Promise<boolean> => {
    const data: Array<ParamCVRequest> = prepareParamCVData(params);

    return hmiclientbase.SetParamCV(data);
};

window.GetParam = function (name: string) {
    let param = GetParamGlobal(name);
    if (param == null) {
        param = hmiclientbase.GetParam(name);
    }
    return param;
};

window.SearchRun = function (str: string) {
    str = str.toUpperCase();

    let nfaceplate = '';
    let blockobj = hmiclientbase.GetItem(str); // + ".faceplate.cv");
    if (blockobj != undefined) {
        nfaceplate = blockobj.path;
    }

    if (nfaceplate != '') {
        window.OpenFaceplate(nfaceplate);
    } else {
        window.OpenMnemoGlobal(str);
    }
};

window.OpenMnemo = async function (name: string, size: string, obj: any) {
    if (window.TypeSystem == TypeSystemEnum.ExperionPks) {
        ExperionScript.OpenMnemo(name, size, obj);
    } else {
        await window.OpenMnemoGlobal(name, size, obj);
    }
};

window.OpenMnemoGlobal = async function (name: string, size: string, obj: any) {
    let gennum: number = 0;
    let binding: any = null;

    let disassembleName = DisassembleName(name);
    name = disassembleName.name;
    gennum = disassembleName.gennum;
    binding = disassembleName.binding;

    if (obj != undefined) {
        await HmiFiles.OpenMnemo(name, gennum, binding, obj, null);
    } else if (size != undefined) {
        //SpecialWin
        if (size.toUpperCase() == 'SPECIALWIN') {
            window.OpenMnemoSpecial(name, gennum, binding, size);
        } else if (size.toUpperCase() == 'SPECIAL') {
            window.OpenMnemoSpecial(name, gennum, binding, size);
        } else if (size.toUpperCase() == 'CENTER') {
            window.OpenMnemoSpecial(name, gennum, binding, size);
        }
        /*
        if (size == "Special") {
            window.OpenWinSpecial(name, gennum, binding);
        }
        else if (size.indexOf("OpenID") == 0) {
            var arraySTR = size.split("&");
            window.OpenNewWindow(name, gennum, binding, arraySTR[1])
        }*/
    } else {
        await window.OpenWinMain(name, gennum, binding);
    }
};

let rootFaceplateManager = window.document.getElementById('rootFaceplateManager');
if (rootFaceplateManager == null) {
    rootFaceplateManager = document.createElement('div');
    rootFaceplateManager.id = 'rootFaceplateManager';
    document.body.appendChild(rootFaceplateManager);

    // ReactDOM.render(React.createElement(FaceplateManager), rootFaceplateManager);

    const root = createRoot(rootFaceplateManager);
    // root.render(React.createElement(FaceplateManager));
    root.render(React.createElement(React.StrictMode, null, React.createElement(FaceplateManager)));
}

window.OpenMnemoSpecial = function (
    name: string,
    gennum: any,
    binding: any,
    size?: string,
    position: 'center' | 'cursor' = 'cursor'
) {
    let titleMnemo = name;
    if (binding != null && binding != '') {
        titleMnemo = titleMnemo + '?' + binding + '';
    }

    if (size?.toUpperCase() == 'CENTER') {
        position = 'center';
        size = 'Special';
    }

    let CallbackRender = function (id: string) {
        let obj = document.getElementById(id);

        let CallbackLoadMnemo = function () {
            let svgelem = (
                document.getElementById(id) as HTMLIFrameElement
            )?.contentWindow?.document.getElementsByTagName('svg')[0];
            if (svgelem != null) {
                let height = svgelem.viewBox.baseVal.height || 100;
                let width = svgelem.viewBox.baseVal.width || 100;

                const svgtitle = svgelem.getAttribute('title');
                let newtitleMnemo = ''; //titleMnemo;
                if (svgtitle != '' && svgtitle != null) {
                    newtitleMnemo = svgtitle;
                }

                const maxHeight = window.innerHeight * 0.9;

                if (height > maxHeight) {
                    const scale = maxHeight / height;
                    width *= scale;
                    height *= scale;
                }
                //изменить размер
                document.dispatchEvent(
                    new CustomEvent('AddFaceplateManager', {
                        detail: {
                            index: titleMnemo,
                            CallbackRender: CallbackRender,
                            title: newtitleMnemo,
                            height: height,
                            width: width,
                            size: size
                        }
                    })
                );
            }
        };
        HmiFiles.OpenMnemo(name, gennum, binding, obj, CallbackLoadMnemo);
    };

    document.dispatchEvent(
        new CustomEvent('AddFaceplateManager', {
            detail: { index: titleMnemo, CallbackRender: CallbackRender, title: '', size: size, position: position }
        })
    );
};

window.CloseMnemo = (mnemoInfo: string) => {
    let objmnemoInfo = JSON.parse(mnemoInfo);

    let titleMnemo = objmnemoInfo.file;
    if (objmnemoInfo.bindings != null && objmnemoInfo.bindings != '') {
        titleMnemo = titleMnemo + '?' + objmnemoInfo.bindings + '';
    }

    document.dispatchEvent(
        new CustomEvent('CloseFaceplateManager', {
            detail: { index: titleMnemo }
        })
    );
};

function DisassembleName(name: string) {
    ///Пробелы в name могут быть
    let gennum: number = 0;
    let binding: any = null;

    let res = {
        name: name,
        binding: {},
        gennum: 0
    };

    if (name.indexOf('{') !== -1) {
        let a = name;
        a = a.substring(a.indexOf('{') + 1);
        gennum = Number(a.substring(0, a.indexOf('}')));
        name = name.substring(0, name.indexOf('{'));
    }
    if (name.indexOf('?') !== -1) {
        let a = name;
        a = a.substring(a.indexOf('?') + 1);
        binding = a.substring(0, a.length);
        name = name.substring(0, name.indexOf('?'));
    }

    res.name = name;
    res.binding = binding;
    res.gennum = gennum;

    return res;
}

window.BeforeMnemoList = [];

window.BeforeMnemo = function () {
    if (window.BeforeMnemoList.length > 1) {
        let opennamemnemo = window.BeforeMnemoList.pop();
        opennamemnemo = window.BeforeMnemoList.pop();
        window.OpenMnemoGlobal(opennamemnemo);
    }
};

window.MaxSpecialWindow = 2;
window.LeftMain = 0;
window.TopMain = 0;

window.OpenWinSpecial = function (name: string, gennum: any, binding: any, curpositionopen: boolean = true) {
    if (window.TypeSystem == TypeSystemEnum.ExperionPks) {
        ExperionScript.OpenWinSpecial(name, gennum, binding, curpositionopen);
    } else {
        OpenWinSpecialStandart(name, gennum, binding, curpositionopen);
    }
};

let OpenWinSpecialStandart = function (name: string, gennum: any, binding: any, curpositionopen: boolean = true) {
    let newid = name + gennum + binding;
    let Specialwinall = document.getElementsByClassName('specialwin');
    for (let i = 0; i < Specialwinall.length; i++) {
        Specialwinall[i].classList.remove('active');
    }

    let clientX = 50;
    let clientY = 50;
    if (window.EventMouseClick) {
        clientX = window.EventMouseClick.clientX + window.LeftMain;
        clientY = window.EventMouseClick.clientY + window.TopMain;
    }

    let specialwinold = document.getElementById(newid);
    if (specialwinold) {
        let Left =
            document.body.offsetWidth - specialwinold.offsetWidth > clientX
                ? clientX
                : document.body.offsetWidth - specialwinold.offsetWidth;
        let Top =
            document.body.offsetHeight - specialwinold.offsetHeight > clientY
                ? clientY
                : document.body.offsetHeight - specialwinold.offsetHeight;
        specialwinold.style.left = Left + 'px';
        specialwinold.style.top = Top - 40 + 'px';
        specialwinold.classList.add('active');
        return;
    }

    if (Specialwinall.length >= window.MaxSpecialWindow) Specialwinall[0].remove();

    let specialwin = document.createElement('div');

    specialwin.id = name + gennum + binding;
    specialwin.style.zIndex = '10';
    specialwin.style.display = 'block';
    specialwin.style.visibility = 'hidden';
    specialwin.className = 'specialwin active';

    let heatspecial = document.createElement('div');
    heatspecial.className = 'heatsspecial';
    specialwin.appendChild(heatspecial);

    let heatspecialname = document.createElement('div');
    heatspecialname.className = 'heatspecialname';
    heatspecialname.style.cursor = 'default';
    heatspecialname.style.userSelect = 'none';
    heatspecial.appendChild(heatspecialname);

    let heatspecialclose = document.createElement('div');
    heatspecialclose.className = 'heatspecialclose';
    heatspecialclose.innerHTML =
        ' <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><path fill = "#cccccc" d = "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z" ></path></svg>';

    heatspecial.appendChild(heatspecialclose);

    let specialframe = document.createElement('iframe');
    specialframe.className = 'mnemoframe';
    specialwin.appendChild(specialframe);

    let callbackload = function () {
        let svgschem = null;
        if (specialframe.contentWindow) svgschem = specialframe.contentWindow.document.getElementsByTagName('svg')[0];

        if (svgschem) {
            let heightallborder = 20;
            if (svgschem.viewBox.baseVal.height !== 0)
                specialwin.style.height = svgschem.viewBox.baseVal.height + heightallborder + 'px';
            if (svgschem.viewBox.baseVal.width !== 0) specialwin.style.width = svgschem.viewBox.baseVal.width + 'px';

            if (curpositionopen) {
                let Left =
                    document.body.offsetWidth - specialwin.offsetWidth > clientX
                        ? clientX
                        : document.body.offsetWidth - specialwin.offsetWidth;
                let Top =
                    document.body.offsetHeight - specialwin.offsetHeight > clientY
                        ? clientY
                        : document.body.offsetHeight - specialwin.offsetHeight;
                specialwin.style.left = Left + 'px';
                specialwin.style.top = Top - 40 + 'px';
            } else {
                let cou = document.getElementsByClassName('MnemoSpecial').length - 1;
                specialwin.style.left = 10 + cou + 'vw';
                specialwin.style.top = 5 + cou + 'vh';
            }

            if (svgschem.hasAttribute('title')) {
                let titl: string = '';
                try {
                    titl = eval(svgschem.getAttribute('title') as string);
                } catch (err) {
                    titl = svgschem.getAttribute('title') as string;
                }

                specialwin.getElementsByClassName('heatspecialname')[0].innerHTML = titl;

                specialwin.getElementsByClassName('heatspecialname')[0].setAttribute('title', titl);
            }

            specialwin.style.visibility = 'visible';

            let autofocus = svgschem.querySelector('input[type="text"]') as any;
            if (autofocus) {
                autofocus.select();
            }
        }
    };

    HmiFiles.OpenMnemo(name, gennum, binding, specialframe, callbackload);

    let mainn = document.getElementById('main');
    if (mainn) mainn.appendChild(specialwin);

    $(specialwin)
        .draggable({
            containment: '#main',
            iframeFix: true,
            handle: '.heatspecialname',
            scroll: false
        })
        .resizable({
            minHeight: 100,
            minWidth: 100,
            handles: 'all',
            aspectRatio: true,
            containment: '#main',
            start: function (event, ui) {
                $('iframe').css('pointer-events', 'none');
            },
            stop: function (event, ui) {
                $('iframe').css('pointer-events', 'auto');
            }
        });

    heatspecialclose.addEventListener('click', function (elem: any) {
        let windowMnemo = elem.target;
        let maxfor = 20;
        for (let i = 0; i < maxfor; i++) {
            windowMnemo = windowMnemo.parentElement;
            if (windowMnemo.className.indexOf('specialwin') !== -1) break;
        }

        let parentElem = windowMnemo.getElementsByClassName('mnemoframe')[0];
        HmiFiles.UnSubItem(parentElem.contentDocument || parentElem.contentWindow.document);
        windowMnemo.parentElement.removeChild(windowMnemo);
    });

    specialwin.addEventListener('mousedown', function () {
        let Specialwin = document.getElementsByClassName('specialwin');
        for (let i = 0; i < Specialwin.length; i++) {
            Specialwin[i].classList.remove('active');
        }
        this.classList.add('active');
    });
};

let alarmcolor = 0;
let messagealarmtext: any;
let activalarmsobj: any;
let ActiveAlarmsAnimation = function () {
    let LastAlarms = hmiclientbase.LastAlarms;
    let AlarmsColor = LastAlarms.State;
    let AlarmStr = ' ';
    if (LastAlarms.Last) {
        if (!messagealarmtext) messagealarmtext = document.getElementById('messagealarmtext') as any;
        if (messagealarmtext) {
            if (LastAlarms.CountNoAck > 0) {
                let lastalarmtxt = LastAlarms.LastNoAck;
                let idalarm = messagealarmtext.getAttribute('idalarm');
                if (idalarm != lastalarmtxt.Id) {
                    AlarmStr =
                        lastalarmtxt.LocationTag +
                        ' ' +
                        lastalarmtxt.ItemName.substring(0, lastalarmtxt.ItemName.indexOf('/')) +
                        ' ' +
                        lastalarmtxt.Name.substring(lastalarmtxt.Name.indexOf('/') + 1, 500) +
                        ' ' +
                        lastalarmtxt.Priority +
                        ' ' +
                        lastalarmtxt.Sevrity +
                        ' ' +
                        lastalarmtxt.Desc +
                        ' ';
                    messagealarmtext.innerHTML = AlarmStr;
                    messagealarmtext.setAttribute('idalarm', lastalarmtxt.Id);
                }
                if (alarmcolor == 0) {
                    messagealarmtext.style.color = 'red';
                } else {
                    messagealarmtext.style.color = '#d6d3ce';
                }
            } else {
                let idalarm = messagealarmtext.getAttribute('idalarm');
                if (idalarm != '') {
                    messagealarmtext.setAttribute('idalarm', '');
                    messagealarmtext.innerHTML = AlarmStr;
                }
            }
        }
    }

    if (!activalarmsobj) activalarmsobj = document.getElementById('ActivAlarms') as any;

    if (activalarmsobj) {
        if ((AlarmsColor & 1) > 0) {
            if ((AlarmsColor & 2) > 0) {
                if (alarmcolor == 0) {
                    activalarmsobj.style.color = '#d6d3ce';
                    alarmcolor = 1;
                } else {
                    activalarmsobj.style.color = 'red';
                    alarmcolor = 0;
                }
            } else {
                activalarmsobj.style.color = 'red';
                alarmcolor = 0;
            }
        } else {
            activalarmsobj.style.color = '#767676';
            alarmcolor = 1;
        }
    }
};

let Intervalanimation: any = null;

///Выполняем при загрузке
window.LoadHashFun = function () {
    this.BeforeMnemoList = [];

    let LoadState = hmiclientbase.LoadState;

    if (!LoadState || !document.getElementById('mainframe')) {
        setTimeout(window.LoadHashFun, 300);
        return;
    }

    setTimeout(function () {
        if (Intervalanimation) {
            clearInterval(Intervalanimation);
            Intervalanimation = null;
        }

        let paramsurl = new URL(window.document.location.href).searchParams;

        if (paramsurl.has('openwinmain')) {
            try {
                let original = paramsurl.get('openwinmain');
                let decodedvalue = original != null ? decodeURIComponent(original) : '';

                let objpar = JSON.parse(decodedvalue);
                window.OpenWinMain(objpar.name, objpar.gennum, objpar.binding);
            } catch {}
        }

        alarmcolor = 0;
        messagealarmtext = null;
        activalarmsobj = null;

        Intervalanimation = setInterval(function () {
            requestAnimationFrame(ActiveAlarmsAnimation);
        }, 1470);
    }, 100);
};

let LoadDefaultFile = function () {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/ixyber/vision/static/js/globalframe.js', true);
    xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status !== 404) {
            HmiFiles.SetScriptDef("<script type='text/javascript'>" + this.responseText + '</script>');
        }
    };
    xhr.send();

    xhr = new XMLHttpRequest();
    xhr.open('GET', '/ixyber/vision/static/css/global.css', true);
    xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status !== 404) {
            HmiFiles.SetStyleDef('<style>' + this.responseText + '</style>');
        }
    };
    xhr.send();

    window.LoadHashFun();
};

document.addEventListener('DOMContentLoaded', LoadDefaultFile);

window.onpopstate = function (event: any) {
    window.LoadHashFun();
};

function getAllUrlParams(url: string) {
    // извлекаем строку из URL или объекта window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // объект для хранения параметров
    let obj: any = {};

    // если есть строка запроса
    if (queryString) {
        // данные после знака # будут опущены
        queryString = queryString.split('#')[0];

        // разделяем параметры
        let arr = queryString.split('&');

        for (let i = 0; i < arr.length; i++) {
            // разделяем параметр на ключ => значение
            let a = arr[i].split('=');

            // обработка данных вида: list[]=thing1&list[]=thing2
            let paramNum = undefined;
            let paramName = a[0].replace(/\[\d*\]/, function (v) {
                paramNum = v.slice(1, -1);
                return '';
            });

            // передача значения параметра ('true' если значение не задано)
            let paramValue = typeof a[1] === 'undefined' ? true : a[1];

            // преобразование регистра
            paramName = paramName.toLowerCase();
            paramValue = typeof paramValue === 'string' ? paramValue.toLowerCase() : paramValue;

            // если ключ параметра уже задан
            if (obj[paramName] != null) {
                // преобразуем текущее значение в массив
                if (typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                }
                // если не задан индекс...
                if (typeof paramNum === 'undefined') {
                    // помещаем значение в конец массива
                    obj[paramName].push(paramValue);
                }
                // если индекс задан...
                else {
                    // размещаем элемент по заданному индексу
                    obj[paramName][paramNum] = paramValue;
                }
            }
            // если параметр не задан, делаем это вручную
            else {
                obj[paramName] = paramValue;
            }
        }
    }

    return obj;
}

window.EventFrameClick = function (event: MouseEvent, obj: any, rectframe: any) {
    if (event) {
        window.EventMouseClick = event;
        window.TopMain = obj.getBoundingClientRect().top + rectframe.y;
        window.LeftMain = obj.getBoundingClientRect().left + rectframe.x;
        windowClick(event);
    }
};

let maxBeforeMnemoList = 15;
window.OpenWinMain = async function (name: string, gennum: any, binding: any) {
    await HmiFiles.OpenMnemo(name, gennum, binding, document.getElementById('mainframe'), null);
    if (window.BeforeMnemoList.length > maxBeforeMnemoList) {
        let nameremove = window.BeforeMnemoList.shift();
    }

    window.BeforeMnemoList.push(name);

    let objarg = {
        name: name,
        gennum: gennum,
        binding: binding
    };

    let search = encodeURIComponent(this.JSON.stringify(objarg));

    SetHref('openwinmain', search);
};

let SetHref = function (name: string, param: string) {
    let urlnew = new URL(window.location.href);
    let queryParams = urlnew.searchParams;
    if (queryParams.has(name)) {
        if (queryParams.get(name) == param) {
            return;
        }
    }
    queryParams.set(name, param);
    window.history.pushState('', name, urlnew.href);
};

window.OpenNewWindow = function (name: string, gennum: any, binding: any, id: string) {
    HmiFiles.OpenMnemo(name, gennum, binding, document.getElementById(id), null);
};

window.OpenFaceplate = function (item: string) {
    item = item.toUpperCase();
    if (item != '' && item != null) {
        let blockobj = hmiclientbase.GetItem(item); // + ".faceplate.cv");
        if (blockobj != undefined) {
            let itemobj = hmiclientbase.GetParam(blockobj.path + '.faceplate.cv');
            if (itemobj.N != itemobj.V && itemobj.V != null && itemobj.V != '') {
                let nface = itemobj.V;
                let tag = blockobj.name;
                let block = blockobj.path.substring(0, blockobj.path.lastIndexOf(tag));
                nface = nface + '?TAG=' + tag + '&BLOCK=' + block;
                window.OpenMnemoGlobal(nface, 'Special', null);
            }
        }
    }
};

window.OpenFaceplateTun = function (item: string) {
    item = item.toUpperCase();
    if (item != '' && item != null) {
        let blockobj = hmiclientbase.GetItem(item); // + ".faceplate.cv");
        if (blockobj != undefined) {
            let itemobj = hmiclientbase.GetParam(blockobj.path + '.faceplate.cv');
            if (itemobj.N != itemobj.V && itemobj.V != null && itemobj.V != '') {
                let nface = itemobj.V + '_TUN';
                let tag = blockobj.name;
                let block = blockobj.path.substring(0, blockobj.path.lastIndexOf(tag));
                nface = nface + '?TAG=' + tag + '&BLOCK=' + block;
                window.OpenMnemoGlobal(nface, 'Special', null);
            }
        }
    }
};

function contextmenudiv(item: string, typemenu: number, x: number, y: number) {
    if (typemenu == 3) return false;
    let fieldNameElement = document.createElement('div');
    fieldNameElement.id = 'menucontext';
    fieldNameElement.style.position = 'absolute';
    fieldNameElement.style.background = '#fff';
    fieldNameElement.style.width = '150px';
    fieldNameElement.style.zIndex = '9999';
    fieldNameElement.style.top = y.toString() + 'px';
    fieldNameElement.style.left = x.toString() + 'px';

    let IdTrend = '';

    let configarch = window.GetArchiveConfig();
    for (let paramarch in configarch) {
        if (paramarch.indexOf(item) == 0) {
            IdTrend = configarch[paramarch].SettingsGroups[0].Group;
            break;
        }
    }

    let menu =
        '<nav class="context-menu">' +
        '<ul class="context-menu__items">' +
        '<li class="context-menu__item">' +
        '<i class="fa fa-item">' +
        item +
        '</i>' +
        '</li>' +
        '<li class="context-menu__item" onclick="OpenFaceplate(\'' +
        item +
        '\')">' +
        '<i class="fa fa-faceplate">Панель</i>' +
        '</li>' +
        '<li class="context-menu__item" onclick="OpenMnemo(\'Trends?Id=' +
        IdTrend +
        '&SELECT=' +
        item +
        '\')">' +
        '<i class="fa fa-trend">Тренды</i>' +
        '</li>' +
        '</ul>' +
        '</nav>';

    fieldNameElement.innerHTML = menu;

    document.body.appendChild(fieldNameElement);
    return true;
}

window.ContextMenu = function (e: any) {
    if (window.TypeSystem != null) {
        e.preventDefault();
        let activeelem = GetElementClick(e);

        if (activeelem) {
            let element = e.target;
            if (e.target.nodeName === 'tspan') {
                element = e.target.parentElement;
            }

            let clickstr = element.getAttribute('onclick').toLowerCase();

            let item = '';

            let typemenu = 1;
            if (clickstr.includes('tag=')) {
                let clickstrmass = clickstr.split('tag=');
                item = clickstrmass.length > 1 ? clickstrmass[1].split("'")[0] : '';
            } else if (clickstr.includes('openfaceplate(')) {
                let clickstrmass = clickstr.split('openfaceplate(');
                item = clickstrmass.length > 1 ? clickstrmass[1].split("'")[1] : '';
            } else if (clickstr.includes('faceplate(')) {
                let clickstrmassfas = clickstr.split('faceplate(');
                item = clickstrmassfas.length > 1 ? clickstrmassfas[1].split("'")[1] : '';
            } else if (e.target.parentNode.hasAttribute('data-value')) {
                typemenu = 3;
            } else {
                typemenu = 2;
            }

            item = item.toUpperCase();

            let clientX = 50;
            let clientY = 50;

            clientX = e.clientX + window.LeftMain;
            clientY = e.clientY + window.TopMain;

            let IdTrend = '';
            let trendparam = '';
            let configarch = window.GetArchiveConfig();
            for (let paramarch in configarch) {
                if (paramarch.indexOf(item) == 0) {
                    IdTrend = configarch[paramarch].SettingsGroups[0].Group;
                    break;
                }
            }
            if (IdTrend != '') {
                trendparam = 'Id=' + IdTrend + '&SELECT=' + item;
            } else {
                trendparam = 'ITEM=' + item + '.CV&SELECT=' + item;
            }

            if (window.TypeSystem == TypeSystemEnum.ExperionPks) {
                return ExperionScript.ContextMenuDiv(e, item, typemenu, clientX, clientY);
            } else if (window.TypeSystem == TypeSystemEnum.CentumVP) {
                return CentumVPScript.ContextMenuDiv(e, item, typemenu, clientX, clientY);
                // } else if (window.TypeSystem == TypeSystemEnum.Pole) {
                //     return window.Pole.AddContextTag(item, clientX, clientY);
            } else if (window.TypeSystem == TypeSystemEnum.WebElement) {
                let funglobal = window.getSystemLib().funglobal;
                if (funglobal) funglobal.ContextMenuDiv(e, item, trendparam, typemenu, clientX, clientY);
            } else {
                return contextmenudiv(item, typemenu, clientX, clientY);
            }
        }
    }
};

window.AddContextTag = function (item: string) {
    const clientX = window.LeftMain;
    const clientY = window.TopMain;
    window.Pole.AddContextTag(item, clientX, clientY);
};

window.AnimationData = function () {
    requestAnimationFrame(async () => {
        await hmidata.AnimationData(true);
    });
};

window.CloseContextMenu = function () {
    let menucontext = document.getElementById('menucontext');
    if (menucontext) {
        document.body.removeChild(menucontext);
    }
};

window.NumberFormat = function (val: any, decimals: any, numberdigital: any) {
    if (typeof val === 'number') {
        if (val < 0 && val > -0.01) val = 0.0;

        if (decimals != undefined) val = hmidata.Decimals(val, decimals);
        if (numberdigital != undefined) val = hmidata.Numberdigital(val, numberdigital);
    }
    return val;
};

let GetElementClick = function (e: any) {
    let activeelem = false;
    let element = e.target;
    if (e.target.nodeName === 'tspan') {
        element = e.target.parentElement;
    } else if (e.target.nodeName.toLowerCase() === 'foreignobject') {
        element = e.target.parentElement;
    }

    if (element.hasAttribute('onclick')) {
        let textclick = element.getAttribute('onclick').toLowerCase();
        if (
            textclick.indexOf('openmnemo') != -1 ||
            textclick.indexOf('openfaceplate') != -1 ||
            textclick.indexOf('faceplate(') != -1
        ) {
            activeelem = true;
        }
    }

    return activeelem;
};

export const getHistoryHost = (): string => {
    return window.hostdata?.replace('/base', '/history');
};

export const getBaseHost = (): string => {
    return window.hostdata;
};

function contextListener() {
    document.addEventListener('contextmenu', function (e) {
        window.CloseContextMenu();
        window.ContextMenu(e);
    });

    document.addEventListener('click', function (e) {
        window.CloseContextMenu();
    });
}

contextListener();
